import { useCallback } from 'react';
import { MembersV2ListItem } from './types';
import { MemberSearchItem } from './types';
import { ROW_TYPES } from './constants';
import { useAccountImpersonationMenu } from 'TeamModule/components/ImpersonateAccountMenu/useAccountImpersonationMenu';
import type { MemberImpersonationItem } from 'TeamModule/api/membersImpersonationApi';

export const useMembersV2ListItemBuilder = () => {
  const { openAccountImpersonationMenu } = useAccountImpersonationMenu();

  const builder = useCallback(
    ({
      members,
      expandedIds,
      impersonationMap,
      isLoadingImpersonation,
      isImpersonationError,
    }: {
      members: MemberSearchItem[];
      expandedIds: Set<string>;
      impersonationMap: Map<string, MemberImpersonationItem>;
      isLoadingImpersonation: boolean;
      isImpersonationError: boolean;
    }) => {
      const header: MembersV2ListItem = {
        id: ROW_TYPES.HEADER,
        rowType: ROW_TYPES.HEADER,
        isStickyHeader: true,
      };

      const dataRows: MembersV2ListItem[] = members.map((member) => {
        const impersonationItem = impersonationMap.get(member.id);

        return {
          id: member.id,
          rowType: ROW_TYPES.DATA,
          member,
          impersonationItem,
          isLoadingImpersonation,
          isImpersonationError,
          onImpersonate: (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            const anchor = e.currentTarget as HTMLElement;
            const teamId = Number(member.teamId);

            if (
              impersonationItem?.accountId &&
              impersonationItem?.tags &&
              Number.isFinite(teamId)
            ) {
              openAccountImpersonationMenu({
                target: anchor,
                accountId: impersonationItem.accountId,
                teamId,
                tags: impersonationItem.tags,
                tenant: member.tenant,
                realmId: member.realmId,
              });
            }
          },
          listItems: [
            {
              id: `${member.id}-details`,
              rowType: ROW_TYPES.DETAILS,
              member,
              collapseProps: {
                shouldWrapWithCollapse: true,
                isCollapse: expandedIds.has(member.id),
              },
              isFullWidthRow: true,
            },
          ],
        };
      });

      return [header, ...dataRows];
    },
    [openAccountImpersonationMenu],
  );

  return builder;
};

export default useMembersV2ListItemBuilder;
